import React, { useState, useEffect, useRef } from 'react';
import SearchSuggestions from '../SearchSuggestions/SearchSuggestions';
import styles from './SearchBar.module.scss';
import classNames from 'classnames/bind';
import { LoaderCircle, Search } from 'lucide-react';
import useDebounce from '../../hooks/useDebounce';
import { searchProducts } from '../../services/Products/ProductServices';

const cx = classNames.bind(styles)

const SearchBar = ({ searchPlaceholder }) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [limit, setLimit] = useState(6)
  const searchRef = useRef(null);

  const debouncedValueSearch = useDebounce(searchValue, 500)

  useEffect(() => {
    const fetchSearch = async () => {
      if (!debouncedValueSearch.trim()) {
        return
      }
      setIsLoading(true)
      let res = await searchProducts(debouncedValueSearch, limit)

      if (res) {
        setSearchResults(res)
      }
      setIsLoading(false)
      setShowSuggestions(true)
    }
    fetchSearch()
  }, [debouncedValueSearch, limit])

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };
  // Click outside để đóng suggestions
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const HandleSearch = () => {
    setLimit(15)
  }

  return (
    <div className={cx("search_container")} ref={searchRef}>
      <div className={cx('search')}>
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={handleInputChange}
          className={cx("search_input")}
        />
        {isLoading ? (
          <LoaderCircle className={cx("search__icon", { "loader": isLoading })} />
        ) : <Search size={16} className={cx("search__icon")} onClick={HandleSearch} />}
      </div>
      <SearchSuggestions
        isVisible={showSuggestions}
        searchResults={searchResults}
      />
    </div>
  );
};

export default SearchBar;